export default __webpack_public_path__ + "static/media/fontainebleau2.9ddfb041.jpg";